module.exports = {
  footerText: 'Copyright RadiScan © 2026',
}